<div class="cards-container">
  <div class="page-header">
    <div class="header-content">
      <button class="back-btn" (click)="goBack()">
        <i class="pi pi-arrow-left"></i>
        <span>Back</span>
      </button>
      <div class="title-section">
        <h1 class="page-title">My Cards</h1>
        <p class="page-subtitle">Manage your linked debit cards</p>
      </div>
      @if (supportsSavedCards() === true) {
        <button class="add-btn" (click)="goToAddCard()">
          <i class="pi pi-plus"></i>
          <span>Add Card</span>
        </button>
      }
    </div>
  </div>

  <div class="content">
    @if (isLoading()) {
      <div class="marketplace-preloader">
        <div class="phone-preloader">
          <div class="phone-frame">
            <div class="phone-screen">
              <div class="phone-notch"></div>
              <div class="rolling-ball-container">
                <div class="rolling-ball"></div>
              </div>
              <div class="loading-dots">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </div>
        </div>
        <p class="preloader-text">Loading cards...</p>
      </div>
    } @else if (error()) {
      <div class="error-state">
        <i class="pi pi-exclamation-triangle"></i>
        <p>{{ error() }}</p>
        <button class="retry-btn" (click)="loadCards()">Retry</button>
      </div>
    } @else if (cards().length === 0) {
      <div class="empty-state">
        <i class="pi pi-credit-card"></i>
        <h2>No Cards Found</h2>
        <p>You haven't added any debit cards yet.</p>
        @if (supportsSavedCards() === true) {
          <button class="add-card-btn" (click)="goToAddCard()">
            <i class="pi pi-plus"></i>
            <span>Add Your First Card</span>
          </button>
        }
      </div>
    } @else {
      <div class="cards-grid">
        @for (card of cards(); track card.id) {
          <div class="virtual-card-wrapper">
            <!-- Virtual ATM Card -->
            <div class="virtual-card" [class.inactive]="!card.isActive" [class]="'card-' + (card.cardType?.toLowerCase() || 'default')">
              <div class="card-front">
                <div class="card-top-section">
                  <div class="card-chip"></div>
                  <div class="card-type-icon">
                    <i class="pi pi-credit-card"></i>
                  </div>
                </div>
                
                <div class="card-number-display">
                  {{ getMaskedCardNumber(card.last4) }}
                </div>
                
                <div class="card-bottom-section">
                  <div class="card-holder-info">
                    <div class="card-holder-label">CARDHOLDER</div>
                    <div class="card-holder-name">{{ authService.getUser()?.firstName }} {{ authService.getUser()?.lastName }}</div>
                  </div>
                  <div class="card-meta">
                    <div class="card-bank-info">
                      <div class="card-bank-label">BANK</div>
                      <div class="card-bank-name">{{ card.bank || 'N/A' }}</div>
                    </div>
                    <div class="card-env-info">
                      <div class="card-env-label">ENV</div>
                      <div class="card-env-value" [class.test]="card.environmentType === 1" [class.live]="card.environmentType === 2">
                        {{ getEnvironmentDisplay(card.environmentType) }}
                      </div>
                    </div>
                  </div>
                </div>
                
                <div class="card-status-indicator" [class.active]="card.isActive" [class.inactive]="!card.isActive">
                  <span class="status-dot"></span>
                  <span>{{ card.isActive ? 'Active' : 'Inactive' }}</span>
                </div>
              </div>
            </div>
            
            <!-- Card Actions Below Card -->
            <div class="card-actions-panel">
              <div class="card-info-section">
                <div class="card-info-item">
                  <i class="pi pi-calendar"></i>
                  <span class="info-label">Added</span>
                  <span class="info-value">{{ formatDate(card.createdAt) }}</span>
                </div>
                @if (card.bank) {
                  <div class="card-info-item">
                    <i class="pi pi-building"></i>
                    <span class="info-label">Bank</span>
                    <span class="info-value">{{ card.bank }}</span>
                  </div>
                }
              </div>
              @if (card.isActive) {
                <button class="deactivate-card-btn" (click)="deactivateCard(card)">
                  <i class="pi pi-trash"></i>
                  <span>Deactivate Card</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</div>

<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
